/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { DataTable, Heading, VFlow } from 'bold-ui'
import { useHistoricoZikaDetailQuery } from 'graphql/hooks.generated'
import { HistoricoZikaDetailQuery } from 'graphql/types.generated'
import { memo } from 'react'
import { formatDate } from 'util/date/formatDate'

interface HistoricoZikaPanelProps {
  cpfOuCnsCidadao: string
  uuidAtend: ID
}

type ExamesZikaTable = HistoricoZikaDetailQuery['historicoZikaDetail']['outrosExames'][0]

function HistoricoZikaPanel({ uuidAtend, cpfOuCnsCidadao }: HistoricoZikaPanelProps) {
  const {
    data: { historicoZikaDetail: detalheZika },
    loading,
  } = useHistoricoZikaDetailQuery({
    variables: {
      input: {
        uuidAtend,
        cpfOuCnsCidadao,
        isOrigemPec: false,
      },
    },
  })

  const colunasTabelaResultadoExames = [
    {
      name: 'nome',
      header: 'Nome',
      render: (item) => item.nome,
      style: css`
        width: 30%;
      `,
    },
    {
      name: 'resultado',
      header: 'Resultado',
      render: (item) => item.resultado,
      style: css`
        width: 40%;
      `,
    },
    { name: 'data', header: 'Data de realização', render: (item) => formatDate(item.dataRealizacao) },
  ]

  return (
    <VFlow>
      <Heading level={3}>Resultados de exames</Heading>
      {detalheZika?.outrosExames && (
        <DataTable<ExamesZikaTable>
          rows={detalheZika.outrosExames}
          loading={loading}
          columns={colunasTabelaResultadoExames}
        />
      )}
      <Heading level={5}>Exames de imagem</Heading>
      {detalheZika?.examesDeImagem && (
        <DataTable<ExamesZikaTable>
          rows={detalheZika.examesDeImagem}
          loading={loading}
          columns={colunasTabelaResultadoExames}
        />
      )}
    </VFlow>
  )
}

export default memo(HistoricoZikaPanel)
